import { Component, OnInit, Inject } from '@angular/core';
import { COEFFICIENTS, ENERGY_SAVING_FACTOR, USAGE } from '../../data/coefficients';
import { Subscription } from 'rxjs';
import _ from 'lodash';
import { StorageService } from 'src/app/services/storage.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
@Component({
  selector: 'app-your-savings',
  templateUrl: './your-savings.component.html'
})
export class YourSavingsComponent implements OnInit {


  subscription: Subscription;
  storage: Storage;
  // @Inject(MAT_DIALOG_DATA) public data;
  readonly K1_FACTOR = ENERGY_SAVING_FACTOR;
  readonly USAGE = USAGE;
  private K2_FACTOR: number;
  private percentSavings = 0;

  private savedKilometers = null;
  private savedTrees = null;
  private savedKilos = null;
  private activeFuel = 1;
  private savedTreesText = 'drzewa';

  energySavings = {
    kWh: 0,
    GJ: 0
  };
  savedBulb = {years: 0, months: 0, days: 0, hours: 0};
  savedBulbTexts = {years: '', months: '', days: '', hours: ''};
  savedTV = {years: 0, months: 0, days: 0, hours: 0};
  savedTVTexts = {years: '', months: '', days: '', hours: ''};

  savings = {
    coal: {
      cost: 0,
      co2: 0,
      cars: 0,
      trees: 0,
    },
    gas: {
      cost: 0,
      co2: 0,
      cars: 0,
      trees: 0,
    },
    electric: {
      cost: 0,
      co2: 0,
      cars: 0,
      trees: 0,
    },
    oil: {
      cost: 0,
      co2: 0,
      cars: 0,
      trees: 0,
    }
  };

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    private storageService: StorageService
    ) {
      this.K2_FACTOR = this.K1_FACTOR * 3.6 / 1000;
    }

  ngOnInit() {
    this.activeFuel = 1;
    this.storage = _.cloneDeep(this.storageService.storage);
    // this.storageSubscription();
    this.countSavings();
    this.setActiveFuel(this.activeFuel);
    this.storageSubscription();
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;

      this.countSavings();
      this.setActiveFuel(this.activeFuel);
    });
  }


  private countSavings() {
    const totalLength: number = this.storageService.getWindowTotalLength() / 1000;

    this.energySavings.kWh = this.K1_FACTOR * totalLength;
    this.energySavings.GJ = this.K2_FACTOR * totalLength;

    this.percentSavings = Math.round((this.energySavings.kWh / USAGE) * 100);

    this.savings.coal.cost = this.energySavings.kWh * (COEFFICIENTS[0].price_value / COEFFICIENTS[0].efficiency);
    this.savings.coal.co2 = Math.round(this.energySavings.GJ * (COEFFICIENTS[0].co2_value / COEFFICIENTS[0].efficiency)) / 1000;

    this.savings.gas.cost = this.energySavings.kWh * (COEFFICIENTS[1].price_value / COEFFICIENTS[1].efficiency);
    this.savings.gas.co2 = Math.round(this.energySavings.GJ * (COEFFICIENTS[1].co2_value / COEFFICIENTS[1].efficiency)) / 1000;

    this.savings.electric.cost = this.energySavings.kWh * (COEFFICIENTS[2].price_value / COEFFICIENTS[2].efficiency);
    this.savings.electric.co2 = Math.round(this.energySavings.GJ * (COEFFICIENTS[2].co2_value / COEFFICIENTS[2].efficiency)) / 1000;

    this.savings.oil.cost = this.energySavings.kWh * (COEFFICIENTS[3].price_value / COEFFICIENTS[3].efficiency);
    this.savings.oil.co2 = Math.round(this.energySavings.GJ * (COEFFICIENTS[3].co2_value / COEFFICIENTS[3].efficiency)) / 1000;
    this.countSavedCarsAndTrees();

    const savedBulbDays = this.energySavings.kWh * 1000 / 60; // zaoszczedzone dni dla zarowki 60W
    this.savedBulb = this.countDaysMonthsYears(savedBulbDays);
    this.savedBulbTexts = this.getPlurals(this.savedBulb);
    const savedTVDays = this.energySavings.kWh * 1000 / 80; // zaoszczedzone dni dla TV 80W
    this.savedTV = this.countDaysMonthsYears(savedTVDays);
    this.savedTVTexts = this.getPlurals(this.savedTV);

    this.energySavings.kWh = Math.round(this.energySavings.kWh);

  }

  countSavedCarsAndTrees() {
    this.savings.coal.cars = Math.round(this.savings.coal.co2 * 1000 / COEFFICIENTS[0].car_co2);
    this.savings.coal.trees = Math.round(this.savings.coal.co2 * 1000 / COEFFICIENTS[0].tree_co2);
    this.savings.gas.cars = Math.round(this.savings.gas.co2 * 1000 / COEFFICIENTS[0].car_co2);
    this.savings.gas.trees = Math.round(this.savings.gas.co2 * 1000 / COEFFICIENTS[0].tree_co2);
    this.savings.electric.cars = Math.round(this.savings.electric.co2 * 1000 / COEFFICIENTS[0].car_co2);
    this.savings.electric.trees = Math.round(this.savings.electric.co2 * 1000 / COEFFICIENTS[0].tree_co2);
    this.savings.oil.cars = Math.round(this.savings.oil.co2 * 1000 / COEFFICIENTS[0].car_co2);
    this.savings.oil.trees = Math.round(this.savings.oil.co2 * 1000 / COEFFICIENTS[0].tree_co2);
  }
  countDaysMonthsYears(hours) {
    const time = {
      years: 0,
      months: 0,
      days: 0,
      hours: 0
    };
    time.years = Math.floor(hours / 24 / 365);
    let leftHours = hours - time.years * 365 * 24;
    time.months = Math.floor(leftHours / 24 / 30);
    leftHours = leftHours - time.months * 30 * 24;
    time.days = Math.floor(leftHours / 24);
    leftHours = leftHours - time.days * 24;
    time.hours = Math.floor(leftHours);
    return time;
  }

  setActiveFuel(id) {

    this.activeFuel = id;
    switch (id) {
      case 1:
        this.savedKilometers = this.savings.gas.cars;
        this.savedTrees = this.savings.gas.trees;
        this.savedKilos = this.savings.gas.co2 * 1000;
        break;
      case 2:
        this.savedKilometers = this.savings.coal.cars;
        this.savedTrees = this.savings.coal.trees;
        this.savedKilos = this.savings.coal.co2 * 1000;
        break;
      case 3:
        this.savedKilometers = this.savings.oil.cars;
        this.savedTrees = this.savings.oil.trees;
        this.savedKilos = this.savings.oil.co2 * 1000;
        break;
      case 4:
        this.savedKilometers = this.savings.electric.cars;
        this.savedTrees = this.savings.electric.trees;
        this.savedKilos = this.savings.electric.co2 * 1000;
        break;
      default:
        this.activeFuel = null;
        break;
    }
    this.savedTreesText = this.setTreesPlural();
  }

  setTreesPlural() {
    const trees = this.savedTrees;
    if (trees === 1) {
      return 'drzewo';
    } else if (
      trees % 10 === 2 && trees % 100 !== 12 ||
      trees % 10 === 3 && trees % 100 !== 13 ||
      trees % 10 === 4 && trees % 100 !== 14) {
      return 'drzewa';
    } else {
      return 'drzew';
    }
  }
  getPlurals(time) {
    const plurals = {years: '', months: '', days: '', hours: ''};

    plurals.years = this.getPluralsYears(time.years);
    plurals.months = this.getPluralsMonths(time.months);
    plurals.days = this.getPluralsDays(time.days);
    plurals.hours = this.getPluralsHours(time.hours);
    return plurals;
  }

  getPluralsYears(years) {
    if (years === 1) {
      return 'rok';
    } else if (
      years % 10 === 2 && years % 100 !== 12 ||
      years % 10 === 3 && years % 100 !== 13 ||
      years % 10 === 4 && years % 100 !== 14) {
      return 'lata';
    } else {
      return 'lat';
    }
  }

  getPluralsMonths(months) {
      if (months === 1) {
        return 'miesiąc';
      } else if (
        months % 10 === 2 && months % 100 !== 12 ||
        months % 10 === 3 && months % 100 !== 13 ||
        months % 10 === 4 && months % 100 !== 14) {
        return 'miesiące';
      } else {
        return 'miesięcy';
      }

  }

  getPluralsDays(days) {
    switch (days) {
      case 1:
        return 'dzień';
      default:
        return 'dni';
    }
  }

  getPluralsHours(hours) {
    if (hours === 1) {
      return 'godzina';
    } else if (
      hours % 10 === 2 && hours % 100 !== 12 ||
      hours % 10 === 3 && hours % 100 !== 13 ||
      hours % 10 === 4 && hours % 100 !== 14) {
      return 'godziny';
    } else {
      return 'godzin';
    }
  }
}
